/* Existing visual index, on-demand worker, cancellable work, live storefront data. */
(() => {
  'use strict';
  if(customElements.get('fd-photo-search'))return;
  class PhotoSearch extends HTMLElement {
    connectedCallback(){queueMicrotask(()=>this.init());}
    init(){
      if(!this.isConnected || this.controller)return;
      this.controller=new AbortController(); const {signal}=this.controller;
      this.cfg=JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.dialog=this.querySelector('dialog'); this.input=this.querySelector('[data-photo-file]');
      this.preview=this.querySelector('[data-photo-preview]');this.status=this.querySelector('[data-photo-status]');
      this.results=this.querySelector('[data-photo-results]');this.go=this.querySelector('[data-photo-search]');
      this.cancelButton=this.querySelector('[data-photo-cancel]');this.vision=this.querySelector('[data-photo-vision]');this.resultCount=this.querySelector('[data-photo-result-count]');this.token=0;this.busy=false;this.stage='idle';
      this.opener=this.closest('section')?.querySelector('#fdsOpen');
      if(!this.dialog.showModal){if(this.opener)this.opener.hidden=true;return;}
      this.opener?.addEventListener('click',()=>{this.dialog.showModal();this.querySelector('[data-photo-close]').focus();},{signal});
      this.querySelector('[data-photo-close]').addEventListener('click',()=>this.dialog.close(),{signal});
      this.dialog.addEventListener('close',()=>{this.stop();this.opener?.focus();},{signal});
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},{signal});
      this.input.addEventListener('change',()=>this.choose(this.input.files[0]),{signal});
      this.go.addEventListener('click',()=>this.search(),{signal});
      this.cancelButton.addEventListener('click',()=>this.stop('Recherche annulée. Tu peux choisir une autre photo.'),{signal});
    }
    setStage(stage,message){
      this.stage=stage;this.dataset.aiStage=stage;
      if(message)this.status.textContent=message;
      const order=['ready','scan','match','verify'],index=order.indexOf(stage);
      this.querySelectorAll('[data-ai-step]').forEach(step=>{
        const i=order.indexOf(step.dataset.aiStep);
        step.classList.toggle('is-active',i===index);
        step.classList.toggle('is-done',index>i||stage==='results');
      });
    }
    setBusy(busy){
      this.busy=busy;this.classList.toggle('is-busy',busy);
      this.go.disabled=busy||!this.image;this.input.disabled=busy;this.cancelButton.hidden=!busy;
      this.results.setAttribute('aria-busy',String(busy));
    }
    async choose(file){
      this.stop();this.image=null;this.results.replaceChildren();this.preview.hidden=true;if(this.vision)this.vision.hidden=true;if(this.resultCount)this.resultCount.textContent='';this.classList.remove('has-image','has-results');this.go.disabled=true;this.setStage('idle','Choisis une image pour lancer FootDrop Vision.');
      if(!file)return;
      if(!['image/jpeg','image/png','image/webp','image/avif'].includes(file.type)){this.status.textContent='Utilise une image JPG, PNG, WebP ou AVIF.';return;}
      if(file.size>15*1024*1024){this.status.textContent='Cette photo dépasse 15 Mo. Choisis une version plus légère.';return;}
      if(this.photoURL)URL.revokeObjectURL(this.photoURL);
      const url=URL.createObjectURL(file);this.photoURL=url;const token=++this.token;
      try{
        const image=new Image();image.src=url;await image.decode();
        if(token!==this.token)return;
        if(image.naturalWidth*image.naturalHeight>24000000)throw new Error('large');
        this.image=image;this.preview.src=url;this.preview.hidden=false;if(this.vision)this.vision.hidden=false;this.classList.add('has-image');this.go.disabled=false;
        this.querySelector('[data-photo-file-label]').textContent='Changer de photo';
        this.setStage('ready','Image prête. Analyse automatique…');
        setTimeout(()=>{if(token===this.token&&!this.busy&&this.image)this.search();},120);
      }catch(error){if(token===this.token)this.status.textContent=error.message==='large'?'Cette image est trop grande. Réduis-la avant de réessayer.':'Cette photo ne peut pas être lue. Essaie une autre image.';}
    }
    regions(){
      const image=this.image,w=image.naturalWidth,h=image.naturalHeight,side=Math.min(w,h);
      const clampBox=box=>{
        let [x,y,bw,bh]=box;
        x=Math.max(0,Math.min(w-1,x));y=Math.max(0,Math.min(h-1,y));
        bw=Math.max(1,Math.min(w-x,bw));bh=Math.max(1,Math.min(h-y,bh));
        return [x,y,bw,bh];
      };
      const boxes=[
        [0,0,w,h],
        [(w-side)/2,(h-side)/2,side,side],
        [w*.10,h*.06,w*.80,h*.88],
        [w*.18,h*.10,w*.64,h*.76],
        [w*.18,h*.03,w*.64,h*.60],
        [w*.27,h*.14,w*.46,h*.62]
      ].map(clampBox);
      return boxes.map(box=>{const canvas=document.createElement('canvas');canvas.width=canvas.height=256;const context=canvas.getContext('2d',{willReadFrequently:true});context.fillStyle='#fff';context.fillRect(0,0,256,256);const scale=Math.min(256/box[2],256/box[3]),dw=box[2]*scale,dh=box[3]*scale;context.drawImage(image,...box,(256-dw)/2,(256-dh)/2,dw,dh);return context.getImageData(0,0,256,256).data.buffer;});
    }
    async search(){
      if(!this.image||this.busy)return;
      this.stop();const token=++this.token;this.setBusy(true);this.results.replaceChildren();this.classList.remove('has-results');if(this.resultCount)this.resultCount.textContent='';
      this.setStage('scan','Préparation du moteur visuel…');
      this.workController=new AbortController();
      this.timeout=setTimeout(()=>{if(token===this.token)this.stop('La recherche prend trop de temps. Réessaie ou utilise la recherche par nom.');},180000);
      try{
        if(!this.worker){
          const response=await fetch(this.cfg.worker,{signal:this.workController.signal});if(!response.ok)throw new Error('worker');
          const source=await response.text();if(token!==this.token)return;
          const url=URL.createObjectURL(new Blob([source],{type:'text/javascript'}));
          try{this.worker=new Worker(url,{type:'module'});}finally{URL.revokeObjectURL(url);}
          this.worker.onerror=()=>this.stop('Le moteur photo est indisponible sur ce navigateur. Utilise la recherche par nom.');
        }
        this.worker.onmessage=event=>{
          if(token!==this.token)return;const data=event.data;
          if(data.t==='dl')this.setStage('scan','Chargement du moteur IA…');
          if(data.t==='stage')this.setStage(data.n===2?'scan':'match',data.n===2?'Analyse des formes, couleurs et détails du maillot…':'Comparaison avec les modèles du catalogue…');
          if(data.t==='err'){this.dataset.aiError=data.msg||'worker_error';console.error('[FootDrop Vision]',data.msg||'worker_error');this.stop('La recherche photo a rencontré un problème. Réessaie avec une autre image.');}
          if(data.t==='infer'){this.setStage('scan','Analyse visuelle '+data.i+'/'+data.total+'…');}
          if(data.t==='results'&&data.token===token)this.render(data.items,token);
        };
        const regions=this.regions();this.worker.postMessage({t:'search',token,regions,cfg:this.cfg},regions);
      }catch(error){if(token===this.token&&error.name!=='AbortError')this.stop('La recherche photo est indisponible. Vérifie ta connexion ou recherche par nom.');}
    }
    async render(items,token){
      if(token!==this.token)return;
      this.setStage('verify','Vérification des produits et des prix actuels…');
      const handles=[...new Set((Array.isArray(items)?items:[]).map(item=>item?.[0]).filter(h=>typeof h==='string'&&/^[a-zA-Z0-9_-]+$/.test(h)))].slice(0,20);
      const products=new Array(handles.length);let cursor=0;
      const root=this.cfg.root.endsWith('/')?this.cfg.root:`${this.cfg.root}/`;
      const consumer=async()=>{
        while(cursor<handles.length&&token===this.token){const index=cursor++,handle=handles[index];
          try{const response=await fetch(`${root}products/${encodeURIComponent(handle)}.js`,{signal:this.workController.signal,headers:{Accept:'application/json'}});if(response.ok)products[index]=await response.json();}catch(_){/* Skip unavailable details, never show stale index prices. */}
        }
      };
      await Promise.all([consumer(),consumer(),consumer()]);
      if(token!==this.token)return;
      const isPlayer=p=>/\bplayer(?:\s*version)?\b|\bplayer\s*\/\s*pro\b/i.test((p.title||'')+' '+(Array.isArray(p.tags)?p.tags.join(' '):p.tags||''));
      const live=products.filter(p=>p&&/\bmaillot\b/i.test(p.title||'')&&!/\b(ensemble|short|survetement|survêtement|debardeur|débardeur|coupe[- ]?vent)\b/i.test(p.title||''));
      const deduped=[],seen=new Map();
      live.forEach(product=>{
        const pair=(Array.isArray(product.tags)?product.tags:[]).find(tag=>/^FD_VERIFIED_PAIR:[A-Za-z0-9_-]+$/.test(tag));
        const key=pair||String(product.id||product.handle||'');
        if(!key)return;
        if(!seen.has(key)){seen.set(key,deduped.length);deduped.push(product);return;}
        const index=seen.get(key),current=deduped[index];
        if(isPlayer(current)&&!isPlayer(product))deduped[index]=product;
      });
      deduped.slice(0,12).forEach((product,index)=>{
        const card=window.FDProductCards.create(product,{className:'fs-photo__result',currency:this.cfg.currency||'EUR'});
        if(index===0)card.classList.add('is-ai-top');
        this.results.append(card);
      });
      clearTimeout(this.timeout);this.setBusy(false);
      const n=this.results.children.length;
      this.classList.toggle('has-results',n>0);
      if(this.resultCount)this.resultCount.textContent=n?String(n)+' résultat'+(n>1?'s':''):'';
      if(n)this.setStage('results',n+' correspondance'+(n>1?'s':'')+' vérifiée'+(n>1?'s':'')+'. Les plus proches sont affichées en premier.');
      else this.setStage('ready','Aucun modèle assez proche. Essaie un cadrage plus serré sur le maillot.');
    }
    stop(message){
      this.token++;clearTimeout(this.timeout);this.workController?.abort();
      this.worker?.terminate();this.worker=null;this.setBusy(false);
      if(message)this.status.textContent=message;
    }
    disconnectedCallback(){if(this.controller){this.stop();this.dialog.close();this.controller.abort();this.controller=null;if(this.photoURL)URL.revokeObjectURL(this.photoURL);}}
  }
  customElements.define('fd-photo-search',PhotoSearch);
})();
